export default {
      id: "common__bus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__bus",
      toString: function () {
        return this.url;
      }
    }